// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_F_S","cls2":"common-cls2_7WE common-cls1_F_S"};